module.exports = __webpack_public_path__ + "assets/img/vr-icon.df8fb834.png";